import { Course } from '@mc/api'
import { useStaticData } from '@mc/static-data-react'
import { Variant1PageContent } from '../pages/Variant1PageContent'

export const CMInnovativeSwingV2Experiment = () => {
  const { course } = useStaticData<{ course: Course }>()

  return <Variant1PageContent key={course?.id} />
}
